import { React, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MyMethods from "./components/MyMethods";
import PublicMethods from "./components/PublicMethods";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import "./Dashboard.css";

const useStyles = makeStyles((theme) => ({
  tab: {
    margin: "20px 0px 5px 3%",
  },
}));

const tabStyles = makeStyles({
  root: {
    minHeight: "auto",
    minWidth: "auto",
    padding: 5,
    marginRight: 15,
    textTransform: "capitalize",
    fontSize: "1.1rem",
  },
});

const Methods = () => {
  const [value, setValue] = useState(0);
  const tabClass = tabStyles();
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Tabs
        className={classes.tab}
        indicatorColor="secondary"
        value={value}
        onChange={handleChange}
        aria-label="simple tabs example"
      >
        <Tab className={tabClass.root} label="My Methods" />
        <Tab className={tabClass.root} label="Public Methods" />
      </Tabs>

      {value === 0 && <MyMethods />}
      {value === 1 && <PublicMethods />}
    </>
  );
};

export default Methods;
